<div class="seperator"></div>
<div class="title" mat-dialog-title>Select Agency ID</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple Agency IDs from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Agency ID</mat-label>
            <mat-select multiple [formControl]="sa360AgencyIds">
                <mat-option *ngFor="let agency of data.userProfilesOrAgencies" [value]="agency.id + ''">
                    {{agency.id + ' - ' + agency.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>